import React from 'react';
import { motion } from 'framer-motion';
import { Button } from '../ui/Button';
import { ShieldCheck, Lock, CreditCard, Zap, FileText, MapPin, Rocket } from 'lucide-react';
export function Hero() {
  const features = [{
    icon: <FileText className="w-5 h-5 text-gold-400" data-id="element-94" />,
    text: '100% PDF'
  }, {
    icon: <Zap className="w-5 h-5 text-gold-400" data-id="element-95" />,
    text: 'Acceso en 5 minutos'
  }, {
    icon: <MapPin className="w-5 h-5 text-gold-400" data-id="element-96" />,
    text: 'Adaptado a Argentina'
  }, {
    icon: <Rocket className="w-5 h-5 text-gold-400" data-id="element-97" />,
    text: 'De 0 a tus primeras ventas'
  }];
  const trustBadges = [{
    icon: <ShieldCheck className="w-4 h-4" data-id="element-98" />,
    text: 'Garantía 7 días'
  }, {
    icon: <Lock className="w-4 h-4" data-id="element-99" />,
    text: 'Pago seguro'
  }, {
    icon: <CreditCard className="w-4 h-4" data-id="element-100" />,
    text: 'Mercado Pago'
  }];
  return <section className="relative pt-10 pb-10 md:pt-32 md:pb-32 overflow-hidden md:min-h-screen flex items-center" data-id="element-101">
      {/* Background Effects */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[800px] h-[500px] bg-gold-600/20 blur-[120px] rounded-full pointer-events-none" data-id="element-102" />
      <div className="absolute bottom-0 left-0 w-full h-1/2 bg-gradient-to-t from-dark-900 to-transparent pointer-events-none" data-id="element-103" />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10 w-full" data-id="element-104">
        {/* MOBILE LAYOUT (stacked: brand → title → image → subtitle → CTA) */}
        <div className="lg:hidden flex flex-col items-center text-center" data-id="element-105">
          <motion.div initial={{
          opacity: 0,
          y: -20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} data-id="element-106">
            <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-dark-700 border border-dark-600 mb-4" data-id="element-107">
              <span className="text-lg" data-id="element-108">🚀</span>
              <span className="text-xs font-bold tracking-widest text-gray-300 uppercase" data-id="element-109">
                CM DIGITAL PRO
              </span>
            </div>
          </motion.div>

          <motion.h1 initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.7,
          delay: 0.1
        }} className="text-3xl sm:text-4xl font-black mb-3 leading-[1.1]" data-id="element-110">
            Todo tu sistema de ingresos{' '}
            <span className="text-transparent bg-clip-text bg-gold-gradient" data-id="element-111">
              Listo. Desde hoy.
            </span>
          </motion.h1>

          {/* Image - compact on mobile */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.8,
          delay: 0.2
        }} className="relative w-full max-w-[250px] sm:max-w-[300px] my-4" data-id="element-112">
            <div className="absolute inset-0 bg-gold-500/10 blur-[60px] rounded-full" data-id="element-113" />
            <img src="https://cdn.magicpatterns.com/uploads/wh5EkgtWAedsPdt6Waihh6/mockup_magiss-Paquete_MEGA_para_ganar_dinero.png" alt="Mega Pack Reventa Pro Mockup" className="relative z-10 w-full object-contain drop-shadow-xl" data-id="element-114" />
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.7,
          delay: 0.3
        }} data-id="element-115">
            <p className="text-base text-gray-300 font-medium mb-1" data-id="element-116">
              💸 El sistema N°1 para ganar dinero en Argentina
            </p>
            <p className="text-sm text-gray-400 mb-5" data-id="element-117">
              📱 iPhones + 💻 Productos digitales —{' '}
              <span className="text-gold-400 font-semibold" data-id="element-118">
                Sin experiencia. Sin vueltas.
              </span>
            </p>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.7,
          delay: 0.4
        }} className="flex flex-col items-center gap-4 w-full" data-id="element-119">
            <Button size="lg" className="w-full" onClick={() => document.getElementById('pricing')?.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
          })} data-id="element-120">
              👉 QUIERO MI MEGA PACK AHORA
            </Button>

            <div className="flex flex-wrap justify-center gap-4 text-xs text-gray-400 font-medium" data-id="element-121">
              {trustBadges.map((badge, idx) => <div key={idx} className="flex items-center gap-1.5" data-id="element-122">
                  <span className="text-gold-500" data-id="element-123">{badge.icon}</span>
                  {badge.text}
                </div>)}
            </div>

            {/* Feature badges - compact row on mobile */}
            <div className="grid grid-cols-2 gap-2 w-full mt-2" data-id="element-124">
              {features.map((feature, idx) => <div key={idx} className="flex items-center gap-2 bg-dark-800/50 border border-dark-700 rounded-lg px-2.5 py-2" data-id="element-125">
                  {feature.icon}
                  <span className="text-xs font-medium text-gray-200" data-id="element-126">
                    {feature.text}
                  </span>
                </div>)}
            </div>
          </motion.div>
        </div>

        {/* DESKTOP LAYOUT (original 2-column grid) */}
        <div className="hidden lg:grid lg:grid-cols-2 gap-8 items-center" data-id="element-127">
          <motion.div initial={{
          opacity: 0,
          x: -50
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          duration: 0.8,
          ease: 'easeOut'
        }} className="text-left" data-id="element-128">
            <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-dark-700 border border-dark-600 mb-8" data-id="element-129">
              <span className="text-xl" data-id="element-130">🚀</span>
              <span className="text-sm font-bold tracking-widest text-gray-300 uppercase" data-id="element-131">
                CM DIGITAL PRO
              </span>
            </div>

            <h1 className="text-6xl lg:text-7xl font-black mb-6 leading-[1.1]" data-id="element-132">
              Todo tu sistema de ingresos <br data-id="element-133" />
              <span className="text-transparent bg-clip-text bg-gold-gradient" data-id="element-134">
                Listo. Desde hoy.
              </span>
            </h1>

            <p className="text-2xl text-gray-300 font-medium mb-4" data-id="element-135">
              💸 El sistema N°1 para ganar dinero en Argentina
            </p>

            <p className="text-lg text-gray-400 mb-10 max-w-2xl" data-id="element-136">
              📱 iPhones + 💻 Productos digitales <br data-id="element-137" />
              <span className="text-gold-400 font-semibold" data-id="element-138">
                Sin experiencia. Sin vueltas. Sin perder tiempo.
              </span>
            </p>

            <div className="grid grid-cols-2 gap-4 mb-10 max-w-lg" data-id="element-139">
              {features.map((feature, idx) => <div key={idx} className="flex items-center gap-3 bg-dark-800/50 border border-dark-700 rounded-lg p-3" data-id="element-140">
                  {feature.icon}
                  <span className="text-sm font-medium text-gray-200" data-id="element-141">
                    {feature.text}
                  </span>
                </div>)}
            </div>

            <div className="flex flex-col items-start gap-6" data-id="element-142">
              <Button size="xl" className="animate-pulse-slow" onClick={() => document.getElementById('pricing')?.scrollIntoView({
              behavior: 'smooth',
              block: 'start'
            })} data-id="element-143">
                👉 QUIERO MI MEGA PACK AHORA
              </Button>

              <div className="flex flex-wrap gap-6 text-sm text-gray-400 font-medium" data-id="element-144">
                {trustBadges.map((badge, idx) => <div key={idx} className="flex items-center gap-2" data-id="element-145">
                    <span className="text-gold-500" data-id="element-146">{badge.icon}</span>
                    {badge.text}
                  </div>)}
              </div>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          scale: 0.9,
          y: 50
        }} animate={{
          opacity: 1,
          scale: 1,
          y: 0
        }} transition={{
          duration: 1,
          delay: 0.2,
          ease: 'easeOut'
        }} className="relative lg:h-[700px] flex items-center justify-center" data-id="element-147">
            <div className="absolute inset-0 bg-gold-500/10 blur-[100px] rounded-full" data-id="element-148" />
            <img src="https://cdn.magicpatterns.com/uploads/wh5EkgtWAedsPdt6Waihh6/mockup_magiss-Paquete_MEGA_para_ganar_dinero.png" alt="Mega Pack Reventa Pro Mockup" className="relative z-10 w-full max-w-2xl object-contain drop-shadow-2xl filter contrast-125" data-id="element-149" />
          </motion.div>
        </div>
      </div>
    </section>;
}